import {
  Card,
  CardContent,
  Typography,
  ButtonGroup,
  Button,
} from "@mui/material";

function WordsCount(props) {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="h5" component="h2" gutterBottom>
          1. Set Mnemonic Phrase Word Count
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Please select the number of words to include in the mnemonic phrase:
        </Typography>
        <ButtonGroup
          variant="outlined" // Default to outlined
          aria-label="word count selection"
        >
          {[12, 15, 18, 21, 24].map((count) => (
            <Button
              key={count}
              onClick={() => props.setWordsCount(count)}
              variant={props.wordsCount === count ? "contained" : "outlined"} // Highlight selected
            >
              {count} words
            </Button>
          ))}
        </ButtonGroup>
      </CardContent>
    </Card>
  );
}

export default WordsCount;
